import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { APCourse } from '../../../global/builders/ap_course_builder';
import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';
import { RouterHelper } from '../../../global/helpers/router_helper';
import { APGenericSlot, CourseGroupSlot, WildcardSlot } from '../../builders/ap_generic_slot_builder';
import { APGenericSlotServant } from '../../servants/ap_generic_slot_servant';
import { APProgramSlotServant } from '../../servants/ap_program_slot_servant';
import { DEEMPHASIZE_DROP_AREA, EMPHASIZE_DROP_AREA } from './../../../plan/constants/event_names';

export class CourseGroupCourseList {
  type: string;
  hasCourses: boolean = false;
  isEditable: boolean | string;
  slot: CourseGroupSlot | WildcardSlot;
  start: number;
  end: number;
  limitedCourseSlots: APGenericSlot[];
  filteredCourseSlots: APGenericSlot[];
  showAllCoursesOption: boolean = false;
  allCourseSlotsSize: number;
  isSlotPlanned: boolean;
  isCoursePlanned: boolean;
  filterKey: string;
  limitTo: string;
  isCourseGroupPlanned: boolean;
  optimizedSlot: APGenericSlot;
  showCourseTileButton: boolean = true;
  isPlannedCourseLocked: boolean = false;
  constructor(
    private $state: ng.ui.IStateService,
    private $animate: any,
    private $timeout: any,
    private ngAPUserModeConfig: APUserModeConfig,
    private showLargeCourseGroupCommand: ICommand,
    private ngComponentCommunicatorService: CommunicatorService,
    private routerHelper: RouterHelper
  ) {}
  $onChanges(changes: any) {
    this.isSlotPlanned = APGenericSlotServant.isGenericSlotPlanned(this.slot);
    this.isCoursePlanned = this.isSlotPlanned && !!_4.isEmpty(this.slot.plannedCourse);
    this.allCourseSlotsSize = APProgramSlotServant.isCourseGroupProgramSlot(this.slot.programSlot)
      ? this.slot.programSlot.total_courses
      : 0;
    // this.showAllCoursesOption = !this.isSlotPlanned && !_4.isEmpty(this.limitTo) && _4.lt(parseInt(this.limitTo, 10), this.allCourseSlotsSize)
    // Large Course groups only when courses are more than 10.
    const limitedCourseSlots = _4.take(this.slot.genericSlots, parseInt(this.limitTo, 10));
    this.filteredCourseSlots = _4.isUndefined(this.limitTo)
      ? _4.slice(this.slot.genericSlots, this.start, this.end)
      : limitedCourseSlots;
    this.hasCourses = !_4.isEmpty(this.filteredCourseSlots);
    this.isCourseGroupPlanned = APGenericSlotServant.isGenericSlotPlanned(this.slot);
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
    this.optimizedSlot = _4.omit(this.slot, ['genericSlots']);
    this.optimizedSlot['genericSlots'] = _4.take(this.slot.genericSlots, Math.min(this.allCourseSlotsSize, 10));
    this.isPlannedCourseLocked = _4.get(this.slot, 'isLockedByAdvisor', false);
    // if it is locked, we won't show the course button
    this.showCourseTileButton = this.isCourseGroupPlanned && this.isEditable && !this.isPlannedCourseLocked;
  }

  emphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(EMPHASIZE_DROP_AREA);
  }
  deEmphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(DEEMPHASIZE_DROP_AREA);
  }

  viewAllCourses() {
    this.$animate.enabled(false);
    this.showLargeCourseGroupCommand(this.slot).then(() => {
      const courseGroupStateName = '^.coursegroup';
      this.routerHelper.findStateAndGo(courseGroupStateName, {
        slotId: this.slot.programSlot.id,
        termId: this.slot.termId
      });
    });
  }
}

angular.module('capability-ng-academic-planner').component('courseGroupCourseList', {
  templateUrl:
    'capability-ng-academic-planner/src/global/components/course_group_course_list/course_group_course_list.html',
  bindings: {
    slot: '<',
    type: '@',
    limitTo: '@',
    term: '<',
    filterKey: '<',
    isEditable: '<?',
    start: '<',
    end: '<',
    showAllCoursesOption: '<'
  },
  controller: CourseGroupCourseList
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_group_course_list/course_group_course_list.ts